import { Eyebrow } from "@/components/media/Sections";
import { Check } from "lucide-react";

export const OperatorPackages = ({ packages }) => {
  const list = packages?.packages || [];
  if (!list.length) return null;

  return (
    <>
      <Eyebrow>WHAT'S IN THE BOX</Eyebrow>
      <h2 className="neon mt-3 text-4xl leading-tight sm:text-5xl">{packages.title}</h2>
      <p className="mt-4 max-w-2xl text-base text-muted-foreground md:text-lg">{packages.intro}</p>

      <div className="mt-12 grid gap-6 lg:grid-cols-2">
        {list.map((p) => (
          <div
            key={p.id}
            data-testid={`package-${p.id}`}
            className="flex flex-col border border-border bg-[#141414] p-6 md:p-8"
          >
            <h3 className="display text-3xl uppercase leading-none md:text-4xl">{p.name}</h3>
            {p.price_label ? (
              <div className="display mt-3 text-4xl leading-none text-primary">{p.price_label}</div>
            ) : null}
            {p.summary ? <p className="mt-4 text-base text-white">{p.summary}</p> : null}
            <ul className="mt-6 flex-1 divide-y divide-border/60">
              {(p.items || []).map((item) => (
                <li
                  key={item.id}
                  data-testid={`package-item-${item.id}`}
                  className="flex items-start gap-3 py-3"
                >
                  <Check size={14} className="mt-1 shrink-0 text-primary" />
                  <div className="flex-1">
                    <div className="text-sm text-white">
                      {item.qty ? (
                        <span className="mono mr-2 text-[10px] tracking-widest text-primary">
                          {item.qty}×
                        </span>
                      ) : null}
                      {item.label}
                    </div>
                    {item.note ? (
                      <div className="mono mt-1 text-[10px] leading-relaxed tracking-widest text-muted-foreground">
                        {item.note}
                      </div>
                    ) : null}
                  </div>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>

      {packages.note ? (
        <p
          data-testid="packages-note"
          className="mono mt-10 max-w-3xl border-l-2 border-border pl-4 text-[11px] leading-relaxed text-muted-foreground"
        >
          {packages.note}
        </p>
      ) : null}
    </>
  );
};
